
import React from 'react';
import configData from "../appconfig/config.json";
import { Notification, NotificationGroup } from '@progress/kendo-react-notification';
import { Form, Field, FormElement } from '@progress/kendo-react-form';
import FormContainer from './FormContainer';
import { v4 as uuidv4 } from 'uuid';

import { Button } from '@progress/kendo-react-buttons';
import { FormInput, FormComboBox } from '../core/customComponents';

import { COUNTRY_NAMES } from "../data/countrylist";
import {ID_NAMES} from '../data/IdType';

import toFetchIDValue from '../data/IdTypeCheck';
import { emailValidator, nameValidator, nricValidator, requiredValidator, countryValidator, IDTypeValidator } from '../core/validationRules';
import Loading from './Loading';
import helper from '../data/Helper';

const countries = COUNTRY_NAMES;
const idType = ID_NAMES;

class PersonalDetails extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.updateInputValue = this.updateInputValue.bind(this)
        configData.OtpResendDisabled = true;
        configData.count3TimeToExist = 0;
        configData.RESEND = 0;
        this.timer = 0;
        configData.settimerZero = 0;
        this.startTimer = this.startTimer.bind(this);
        this.countDown = this.countDown.bind(this);

        this.state = {
            OTPValue: '',
            inputuuid: '',

            OtpconfirmDisabled: false,
            tohideNotification: false,
            notificationFlag: false,
            maskSetMobileNumber: '',
            getAllDataValues: '',
            setAllstateValues: {},
            setAllOTPResponces: {},
            setClockTrue: true,
            time: {},
            seconds: configData.setTimeIntOTP, //in sec 3 min 180sec,
            showLoading: false
        };

    }

    secondsToTime(secs) {

        let hours = Math.floor(secs / (60 * 60));
        let divisor_for_minutes = secs % (60 * 60);
        let minutes = Math.floor(divisor_for_minutes / 60);
        let divisor_for_seconds = divisor_for_minutes % 60;
        let seconds = Math.ceil(divisor_for_seconds);

        let obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };

        return obj;

    }

    componentDidMount() {
        //this.startTimer();//remove
        let timeLeftVar = this.secondsToTime(this.state.seconds);
        this.setState({ time: timeLeftVar });
    }

    reSendOTP() {

        this.setState({ OTPValue: "" });
        configData.RESEND = configData.RESEND + 1;
        if (configData.RESEND <= 2) {
            configData.OtpResendDisabled = false;
            clearInterval(this.timer);
            this.state.seconds = configData.setTimeIntOTP;
            this.startTimer();
        } else {
            configData.OtpResendDisabled = true;
            alert("You have exceeded the max OTP request, please try after some time");
            helper.toHomeScreen();
            return;
        }
    }
    //timer set starts  
    startTimer() {

        this.state.notificationFlag = false;
        if ((this.timer === 0) && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
        } else if (configData.RESEND <= 2 && this.state.seconds > 0) {
            this.timer = setInterval(this.countDown, 1000);
            configData.OtpResendDisabled = true;
        }
    }
    countDown() {
        // Remove one second, set state so a re-render happens.
        let seconds = this.state.seconds - 1;
        this.setState({
            time: this.secondsToTime(seconds),
            seconds: seconds,
        });
        if (seconds === 0) {
            clearInterval(this.timer);
        }
    }

    handleSubmit(event) {

        const responseOBJ = {};
        let requestBody = {
            by_idNum: this.state.nric,
            by_idType: toFetchIDValue("IDTYPE", this.state.idType),
            by_idIssueCountryCode: toFetchIDValue("countries", this.state.countryselected),
            stateId: uuidv4(),
            email: this.state.email,
            prod_Type: configData.PRODUCT_TYPE,
            by_name: this.state.fullname

        }

        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Cache-Control': 'no-cache',//for IE issues
                'Pragma': 'no-cache',
                'Access-Control-Allow-Headers': 'Content-Type'
            },
        };

        if (!requestBody.email) {
            requestBody.email = "";
        }

        // save locally for OTP GENERATION API
        /*
        localStorage.setItem("Otp_nric", requestBody.by_idNum);
        localStorage.setItem("Otp_idtype", requestBody.by_idType);
        localStorage.setItem("Otp_countCode", requestBody.by_idIssueCountryCode);
        localStorage.setItem("Otp_StateIDvalue", requestBody.stateId);
        localStorage.setItem("Otp_email", requestBody.email);
        localStorage.setItem("Otp_Prod_type", requestBody.prod_Type);
        localStorage.setItem("Otp_Name", requestBody.by_name);
        */

        this.setState({ showLoading: true });

        const baseUrl = this.getSaveURL();

        fetch(baseUrl + "?by_idNum=" + requestBody.by_idNum + "&by_idType=" + requestBody.by_idType + "&by_idIssueCountryCode=" + requestBody.by_idIssueCountryCode + "&stateId=" + requestBody.stateId + "&email=" + requestBody.email + "&prod_Type=" + requestBody.prod_Type + "&by_name=" + requestBody.by_name
            , requestOptions)
            .then(async response => {
                this.setState({ showLoading: false });
                const data = await response.json();
                if (!data.didError) {
                    let res = data.model;
                    if (res.token && res.referenceNo) {
                        let tokenid = res.token;
                        let expirytoken = data.tokenExpirationDate;
                        //Reference
                        localStorage.setItem("Ref", res.referenceNo);
                        configData.RefferenceNo = res.referenceNo;//STORING GLOBAL

                        //token id
                        localStorage.setItem("tkn", tokenid);
                        localStorage.setItem("expdte", expirytoken);
                        localStorage.setItem("expid", new Date().getMinutes());

                        if (res.data) {
                            localStorage.setItem("nricval", res.data);
                        }

                        this.props.history.push('Fundtransfer');

                    } else {
                        console.log("error:Token/Reff no ")
                    }

                } else {
                    localStorage.clear();
                    this.props.history.push('error');
                }
            })
            .catch(error => {

                this.setState({
                    errorMessage: error,
                    showLoading: false
                });
                if (configData.RESEND <= 1) {
                }
                console.error('There was an error!', error);

            });
    }

    updateInputValue = async (e) => {
        const re = /^[0-9\b]+$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            await this.setState({ OTPValue: e.target.value });
        }
        if (this.state.OTPValue.length === 6) {
            await this.setState({ OtpconfirmDisabled: true });
        } else {
            await this.setState({ OtpconfirmDisabled: false });
        }
    }

    isNumber = async (evt) => {
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;

        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            await this.setState({ OTPValue: "" });
            await this.setState({ OtpconfirmDisabled: false });
            return false;
        } else {
            return true;
        }
    }

    verifyOTPDetails = async () => {
        console.log('verifyOTPDetails');

        if (this.state.OTPValue) {
            let req = this.state.setAllOTPResponces;
            if (!this.state.email) {
                this.state.email = "";
            }

            const requestBody = {

                //new changes passing details to save at verification
                idNum: this.state.nric,
                idType: toFetchIDValue("IDTYPE", this.state.idType),
                idIssueCountryCode: toFetchIDValue("countries", this.state.countryselected),
                email: this.state.email,
                name: this.state.fullname,
                by_prdType: configData.PRODUCT_TYPE,

                cifNum: req.cifNum,
                otp: this.state.OTPValue,
                mobileNum: "0",//req.mobileNum ? req.mobileNum.substring(3) : '',
                accessID: "00000000",//this.state.setAccessID,
                uniqueRequestid: uuidv4(),//req.uniqueID,
                appId: '0'//configData.AUTH_CODE_Encrypt
            }

            const requestOptions = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Access-Control-Allow-Headers': 'Content-Type',
                    'Cache-Control': 'no-cache',//for IE issues
                    'Pragma': 'no-cache',
                },
                body: JSON.stringify(requestBody)
            };

            this.setState({ showLoading: true });

            const baseUrl = this.getVerifyOTPURL();

            fetch(baseUrl, requestOptions)

                .then(async response => {
                    this.setState({ showLoading: false });
                    const data = await response.json();
                    if (!data.didError) {
                        let res = data.model.msg;
                        let resMsgBdy = res.msgBody;
                        let resMsgHdr = res.msgHdr;

                        if (data.token && data.refNo) {
                            let tokenid = data.token;
                            let expirytoken = data.tokenExpirationDate;
                            //TODO
                            localStorage.setItem("Ref", data.refNo);
                            configData.RefferenceNo = data.refNo;//STORING GLOBAL
                            localStorage.setItem("tkn", tokenid);
                            localStorage.setItem("expdte", expirytoken);
                            localStorage.setItem("expid", new Date().getMinutes());
                            if (resMsgBdy) {
                                localStorage.setItem("nricval", resMsgBdy.nric);
                            }
                            if (resMsgHdr.statusCode === "0") {
                                this.props.history.push('Fundtransfer');
                                this.state.notificationFlag = false;
                            }
                            else {
                                if (resMsgHdr.statusDesc)
                                    configData.count3TimeToExist = configData.count3TimeToExist + 1
                                if (configData.count3TimeToExist <= 3) {
                                    await this.setState({ errorMessage: resMsgHdr.statusDesc });
                                    alert("The OTP entered has expired/is invalid. Please re-enter the 6 Digit OTP.")
                                } else {
                                    alert("You have exceeded the max OTP to confirm, please try after some time");
                                    document.location.href = configData.URL_ToHomeScreen_PROD;
                                    localStorage.clear();
                                    return;
                                }
                            }
                        } else {
                            this.props.history.push('error');
                            localStorage.clear();
                        }
                    } else {
                        this.props.history.push('error');
                        localStorage.clear();
                    }
                })
                .catch(error => {
                    this.setState({ showLoading: false });
                    console.error('There was an error!', error);
                });

        } else {
            await this.setState({ OtpconfirmDisabled: true });
            alert("Please enter valid numeric 6 digit OTP");
        }
    }

    handleChange = async (event) => {
        await this.setState({ email: event.target.value });
    }
    fullNameChange = async (event) => {
        localStorage.setItem('CFN', event.target.value);
        await this.setState({ fullname: event.target.value });
    }
    idTypeChange = async (event) => {

        await this.setState({ idType: event.target.value });
    }
    filterChange = async (event) => {

        await this.setState({ idType: event.target.value });
    }

    countrySelectChange = async (event) => {
        await this.setState({ countryselected: event.target.value });
    }
    nricChange = async (event) => {
        let touppervalue = event.target.value;
        touppervalue = touppervalue.toUpperCase();
        await this.setState({ nric: touppervalue });
    }

    getVerifyOTPURL = () => {
        let baseUrl = configData.URL_VERIFY_OTP_PROD;
        if (configData.SERVER_STATUS === 'SIT') {
            baseUrl = configData.URL_VERIFY_OTP_SIT;
        }
        else if (configData.SERVER_STATUS === 'UAT') {
            baseUrl = configData.URL_VERIFY_OTP_UAT;
        }
        else {
            baseUrl = configData.URL_VERIFY_OTP_PROD;
        }
        return baseUrl;
    }

    getSaveURL = () => {
        let baseUrl = configData.URL_SEND_SAVEDETAILS_PROD;
        if (configData.SERVER_STATUS === 'SIT') {
            baseUrl = configData.URL_SEND_SAVEDETAILS_SIT;
        }
        else if (configData.SERVER_STATUS === 'UAT') {
            baseUrl = configData.URL_SEND_SAVEDETAILS_UAT;
        }
        else {
            baseUrl = configData.URL_SEND_SAVEDETAILS_PROD;
        }
        return baseUrl;
    }

    render() {
        const { tohideNotification } = this.state;
        return (

            <div className="container-fluid">
                <div className='row'>
                    <div className="container mt-5">
                        <h2 className="welcome mb-0">{configData.APP_NAME}</h2>
                    </div>

                    <FormContainer>
                        <Form
                            initialValues={this.state}
                            onSubmit={this.handleSubmit}
                            render={(formRenderProps) => (
                                <FormElement onSubmit={formRenderProps.onSubmit} className={'k-form'}>
                                    <fieldset className={'k-form-fieldset'}>
                                        <div className="row around-xs inputPairelementVisible" style={{ marginTop: "1rem" }}>
                                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                                <legend className={'k-form-legend'}>{configData.HDR_PER_DETAILS}  </legend>
                                            </div>
                                        </div>

                                        <Field id={'fullName'}
                                            name={'fullName'}
                                            label={'Full Name in NRIC/Passport'}
                                            placeholder={'Full Name in NRIC/Passport'}
                                            component={FormInput}
                                            validator={nameValidator}
                                            value={this.state.fullName} onChange={this.fullNameChange} disabled={this.state.notificationFlag} />
                                        <Field id={'nricNumber'} name={'nricNumber'} onChange={this.nricChange} label={'NRIC/Passport Number'} placeholder={'NRIC/Passport Number'} component={FormInput} validator={nricValidator} disabled={this.state.notificationFlag} />

                                        <Field
                                            key={'countryselected'}
                                            id={'countryselected'}
                                            name={'countryselected'}
                                            label={'Issuing Country'}
                                            component={FormComboBox}
                                            onChange={this.countrySelectChange}
                                            data={countries}
                                            validator={countryValidator}
                                            disabled={this.state.notificationFlag} />

                                        <Field
                                            key={'idtype'}
                                            id={'idtype'}
                                            name={'idtype'}
                                            label={'ID Type'}
                                            component={FormComboBox}
                                            data={idType}
                                            onChange={this.idTypeChange}
                                            onFilterChange={this.filterChange}
                                            validator={IDTypeValidator}
                                            disabled={this.state.notificationFlag} />

                                        <Field id={'email'} name={"email"} hint={''} label={'Email Address'} onChange={this.handleChange} type={"email"} placeholder={'Email Address'} component={FormInput} validator={emailValidator} disabled={this.state.notificationFlag} />

                                    </fieldset>


                                    <span className={'k-form-separator'} />

                                    {!this.state.tohideNotification && <div className="text-right" style={{ marginTop: "4rem" }}>
                                        <Button className="btnMaybank"
                                            primary={true}
                                            type={'submit'}
                                            disabled={!formRenderProps.allowSubmit}>{configData.ON_NEXT}</Button>
                                    </div>}
                                    <p style={{ marginTop: "4rem" }}></p>
                                </FormElement>
                            )} />


                        {(tohideNotification) ? (<NotificationGroup
                            style={{
                                right: 0,
                                bottom: 0,
                                alignItems: "flex-start",
                                flexWrap: "wrap-reverse"
                            }} >

                            <Notification
                                type={{ style: "warning", icon: false }}
                                closable={false}>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-1 col-md-1 col-lg-1">
                                        <div className="box">
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-4 col-md-4 col-lg-4">
                                        <div className="box row" style={{ textAlign: "left", color: "black", margin: "10px" }}>
                                            <p>OTP has been sent to  XXXX {this.state.maskSetMobileNumber}</p>
                                            <p>Please confirm  received OTP  with in 2 minutes.</p>
                                        </div>
                                    </div>
                                    {this.state.time.s > 0 && <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                                        <div className="box row" style={{ textAlign: "left", color: "black", margin: "10px" }}>
                                            <div className="text-center" style={{ marginTop: "1rem" }} >
                                                <p data-tip="If you did not receive any, you can requestanother SMS OTP in 2:00" className="" >Resend in  {this.state.time.m} : {this.state.time.s}
                                                    <span className="k-icon k-i-clock" style={{ marginTop: "-2px" }}></span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>}

                                    {this.state.time.s <= 0 && <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                                        <div className="box  row" style={{ margin: "10px" }}>
                                            <div className="text-center" style={{ marginTop: "0.5rem" }} >
                                                {(this.state.time.m <= 0 && this.state.time.s <= 0 && configData.OtpResendDisabled) &&
                                                    <div>
                                                        <Button className="btn btn-success btnMaybank" style={{ padding: "10px" }}
                                                            primary={true}
                                                            onClick={this.handleSubmit}>
                                                            RESEND OTP
                                                        </Button>
                                                    </div>}
                                            </div>
                                        </div>
                                    </div>
                                    }
                                    <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                                        <div className="box"  >
                                            <div className="text-center" style={{ marginTop: "1.5rem" }}>
                                                <input style={{ width: "100%" }} onKeyPress={this.isNumber}
                                                    type="password" pattern="[0-9]+" maxLength="6" minLength="6" value={this.state.OTPValue}
                                                    onChange={this.updateInputValue} placeholder="123456" name="" id="OTPValue" className="k-textbox" ></input>
                                            </div>
                                        </div>
                                    </div>
                                    <br></br>
                                    <div className="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                                        <div className="box">
                                            <div className="text-center" style={{ marginTop: "1rem" }}>
                                                <Button className="btn btn-success btnMaybank" style={{ padding: "13px" }}
                                                    primary={true}
                                                    onClick={this.verifyOTPDetails} disabled={!this.state.OtpconfirmDisabled}>CONFIRM</Button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-1 col-md-1 col-lg-1">
                                        <div className="box">
                                        </div>
                                    </div>
                                </div>
                            </Notification>
                        </NotificationGroup>) : ""}
                    </FormContainer>
                    {this.state.showLoading && <Loading />}
                </div>
            </div>
        )
    }
}

export default PersonalDetails;
